import {
  Feature,
  isFeatureEnabled as isFeatureEnabled_
} from '@dadohr/shared/domainTypes/features';
import { getCurrentUser, useCurrentUser } from '../currentUser';

// @deprecated
export const isFeatureEnabled = (feature: Feature) => {
  const { org } = getCurrentUser();
  return isFeatureEnabled_(org.features, feature);
};

export const useFeatureEnabled = (feature: Feature) => {
  const { org } = useCurrentUser();
  return isFeatureEnabled_(org.features, feature);
};
